import { useProduct } from "src/context/ProductProvider";
import { Stack } from "@mui/material";
import TermsOfConditions from "../TermsOfConditions";
import Display from "./components/Display";
import Header from "../Headers/Header";

const DashboardALaCartePaymentInformation = () => {
  const productSlug = useProduct((p) => p.slug);
  const page = "payment-information";

  const isGlp1 = useProduct((product) => product.is_glp1);

  return (
    <Stack gap={3}>
      <Stack gap={2}>
        <Stack gap={3}>
          <Header />
        </Stack>
      </Stack>
      <Display />
      <TermsOfConditions
        page={page}
        productSlug={productSlug}
        isGlp1={isGlp1}
        numberOfMonths={1}
      />
    </Stack>
  );
};

export default DashboardALaCartePaymentInformation;
